import React from 'react'
import PropTypes from 'prop-types'
import { getShippingText, constants } from 'common/helpers'
import { useFeatures } from 'sb-hooks'
import { injectIntl } from 'sb-react-intl'

import SectionHeadline from 'components/cart/SectionHeadline/SectionHeadline'

import messages from './messages'


const CartSubscriptionTitle = ({ intl, withShipping }) => {
  const { [constants.features.billingDay1stDayOfTheMonth]: isBillingDay1stEnabled } = useFeatures()

  const subTitle = intl.formatMessage(messages.shipping, {
    shippingText: getShippingText(new Date(), isBillingDay1stEnabled),
  })

  return (
    <SectionHeadline
      titleMessage={messages.title}
      subTitleMessage={subTitle}
      withShipping={withShipping}
    />
  )
}

CartSubscriptionTitle.propTypes = {
  withShipping: PropTypes.bool,
  intl: PropTypes.object,
}


export default injectIntl(CartSubscriptionTitle)
